import { render, staticRenderFns } from "./BatchAddMonitor.vue?vue&type=template&id=756f2496&scoped=true"
import script from "./BatchAddMonitor.vue?vue&type=script&lang=js"
export * from "./BatchAddMonitor.vue?vue&type=script&lang=js"
import style0 from "./BatchAddMonitor.vue?vue&type=style&index=0&id=756f2496&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "756f2496",
  null
  
)

export default component.exports